import React, { useRef, useLayoutEffect } from 'react';
import { InputTitle } from './styles';

const AutoResizingInputTitle = ({ value = '', onChange, ...props }) => {
  const textAreaRef = useRef(null);

  const adjustHeight = () => {
    const textArea = textAreaRef.current;
    if (textArea) {
      textArea.style.height = '48px'; // altura base
      textArea.style.height = `${textArea.scrollHeight}px`; // ajusta al contenido
    }
  };

  useLayoutEffect(() => {
    adjustHeight();
  }, [value]);

  const handleInput = e => {
    adjustHeight();
    onChange(e);
  };

  return (
    <InputTitle
      ref={textAreaRef}
      value={value}
      onInput={handleInput}
      onChange={onChange}
      data-publi='step-description-title-textArea'
      {...props}
    />
  );
};

export default AutoResizingInputTitle;
